import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzI18nService, zh_CN, en_US, ar_EG, zh_TW, fr_FR } from 'ng-zorro-antd/i18n';
import { NotificationEventService } from './notificationEvent.service';
import { AuthService } from './auth.service';
import { DEFAULT_CURRENT_LANGUAGE, DEFAULT_CURRENT_NG_LANGUAGE, tranlatedLanguage } from 'app/common/constants';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  translate = inject(TranslateService);
  nzI18n = inject(NzI18nService);
  notificationEventService = inject(NotificationEventService);
  authService = inject(AuthService);
  private currentLocale = DEFAULT_CURRENT_NG_LANGUAGE;

  constructor(
  ) {
    this.translate.addLangs(tranlatedLanguage);
    const browserLang = this.translate.getBrowserLang();
    let nowLanguageStatus = browserLang ? tranlatedLanguage.includes(browserLang) ? browserLang : DEFAULT_CURRENT_LANGUAGE : DEFAULT_CURRENT_LANGUAGE;
    this.translate.setDefaultLang(nowLanguageStatus);
    this.notificationEventService.languageEvent.next(nowLanguageStatus)
    this.useLanguage(nowLanguageStatus);
  }

  useLanguage(lang: string, userSwitchFlag?: boolean): void {
    this.translate.use(lang);
    switch (lang) {
      case 'zh':
        this.nzI18n.setLocale(zh_CN);
        this.setLocale('zh-CN');
        document.documentElement.dir = 'ltr';
        break;
      case 'zh_TW':
        this.nzI18n.setLocale(zh_TW);
        this.setLocale('zh-TW');
        document.documentElement.dir = 'ltr';
        break;
      case 'en':
        this.nzI18n.setLocale(en_US);
        this.setLocale('en-US');
        document.documentElement.dir = 'ltr';
        break;
      case 'fr':
        this.nzI18n.setLocale(fr_FR);
        this.setLocale('fr-FR');
        document.documentElement.dir = 'ltr';
        break;
      case 'ar':
        this.nzI18n.setLocale(ar_EG);
        this.setLocale('ar');
        // document.documentElement.dir = 'rtl';
        break;
      default:
        lang = DEFAULT_CURRENT_LANGUAGE;
        this.nzI18n.setLocale(zh_CN);
        this.setLocale(DEFAULT_CURRENT_NG_LANGUAGE);
        document.documentElement.dir = 'ltr';
    }
    this.notificationEventService.languageEvent.next(lang)

    if (userSwitchFlag) {
      const user = this.authService.getUser();
      if (user) {
        const userId = user._id;
        localStorage.setItem(userId + '_lang', lang);
      }
    }
  }

  getCurrentLocale(): string {
    return this.currentLocale;
  }

  setLocale(locale: string): void {
    this.currentLocale = locale;
  }
}